import {
	Pagination as PaginationComponent,
	type PaginationProps as PaginationPropsType
} from './Pagination';

export const Pagination = PaginationComponent;
export type PaginationProps = PaginationPropsType;
